import { useState, useEffect } from "react";
import { axiosAuth, axiosNoAuth } from "../config/axiosInstances";
import { Api_url } from '../common/api_url';
import { API_XANO_BASE_URL } from '../config/api_config';

const getDoubtPage = async (lesson_id , page = 1, options={}) => {
    const response = await axiosAuth.get(
        "https://xgfy-czuw-092q.m2.xano.io/api:ltai_router/doubt_solver/asked_doubts",
        {
          params: {
            lesson_id,
            page
          },
        }
      );
      console.log('contentId2' ,response.data);
    return response.data.data;
}

const useDoubtData = (lesson_id , pageNum = 1) => {
    const [usersData, setUsersData] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [isError, setIsError] = useState(false)
    const [error, setError] = useState({})
    const [hasNextPage, setHasNextPage] = useState(false)

    console.log('contentId' , lesson_id);
    useEffect(() => {
      if(pageNum > 1){
        setIsLoading(true)
        setIsError(false)
        setError({})

        const controller = new AbortController()
        const { signal } = controller

        getDoubtPage(lesson_id , pageNum)
        .then(result => {
          console.log('result' , result);
            setUsersData((prev) => ([...prev, ...result]))
            setHasNextPage(Boolean(result.length))
            setIsLoading(false)

        }).catch(e => {
            setIsLoading(false)
            if (signal.aborted) return
            setIsError(true)
            setError({message: e.message})
        })

        return () => controller.abort()
      }
    }, [pageNum])

    useEffect(()=>{

     
      setIsLoading(true)
      setIsError(false)
      setError({})

      const controller = new AbortController()
      const { signal } = controller

      getDoubtPage(lesson_id , pageNum)
      .then(result => {
        console.log('result' , result);
          setUsersData((prev) => ([...prev, ...result]))
          setHasNextPage(Boolean(result.length))
          setIsLoading(false)

      }).catch(e => {
          setIsLoading(false)
          if (signal.aborted) return
          setIsError(true)
          setError({message: e.message})
      })

      return () => {
        setUsersData([]);
        setIsLoading(false);
        setIsError(false);
        setError({});
        setHasNextPage(false);
        controller.abort()}

    }, [lesson_id])

    return {usersData, isLoading, isError, error, hasNextPage}
}

export default useDoubtData